<template>
  <div class="js-report-main">
    <Input textAlign="center" placeholder="Job Sheet" :inputValue.sync="jobNo" @enter="pdfClicked"/>
    <button @click="pdfClicked">Generate Report</button>
    <Loader :isVisible.sync="loading" :loadingText="loadText" :isFullScreen="true" />
    <div class="error-message">{{ errorMessage }}</div>
    <iframe v-if="pdfLink" :src="pdfLink" id="iframe" frameborder="0"></iframe>
  </div>
</template>

<script>
/* eslint-disable */
import Loader from '@/components/Loader.vue';
import Input from '@/components/Input.vue';
import Axios from 'axios';

export default {
  components: {
    Loader, Input,
  },
  props: {
    jobNo: { type: String, default: 'FE20121380' },
    loading: { type: Boolean, default: false },
    loadText: { type: String, default: '' },
    errorMessage: { type: String, default: '' },

    config: { type: String, default: 'fmg6g' },
    userID: { type: String, default: 'Azizi6g' },

    pdfLink: { type: String, default: '' },

    // Link to test
    // https://localhost:5001/GenerateJS/fmg6g/Azizi6g/FE20121380
  },
  methods: {
    pdfClicked: async function() {
      this.errorMessage = '';
      if (!this.jobNo) {
        this.errorMessage = 'Please enter your Job No';
        return;
      }

      this.loading = true;
      this.loadText = 'Getting Report Details';
      var jsDetails = await this.$apiCallV2(`/Report/GetJobDetails?config=${this.config}&userID=${this.userID}&jobno=${this.jobNo}`);
      if (!jsDetails) {
        console.log('Please check your config code');
        this.loading = false;
        return;
      }

      console.log(jsDetails.JobDetails.Job);
      this.loading = false;

      if (jsDetails.length == 0) {
        this.loading = false;
        this.errorMessage = `Invalid Job No '${this.jobNo}'.\nPlease enter a valid Job No`;
        return;
      }

      try {
        this.loading = true;
        this.loadText = 'Creating Report';

        let headerInfo = {
          'Content-Type': 'application/json',
          'Authorization': 'Basic YWRtaW46ZG1fNTU2OWRz'
        };

        var jsReportPDF = await Axios.post('https://dsm.logistics.systems:5488/api/report', {
          template: { shortid: 'ofztrcpu5B' },
          data: jsDetails.JobDetails.Job,
          options: { 'Content-Disposition': 'attachment;filename=report.pdf' }
        }, {
          headers: headerInfo,
          responseType: 'arraybuffer',
        });
        this.loading = false;

        var contentType = jsReportPDF.headers['content-type'];
        var blob = new Blob([ jsReportPDF.data ], { type: contentType });
        console.log(blob);
        var url = window.URL.createObjectURL(blob, { oneTimeOnly: false });
        console.log(url);
        var link = document.createElement('a');
        link.href = url;
        this.pdfLink = url;

        setTimeout(() => {
          var frame = document.getElementById('iframe').contentWindow;
          frame.focus();
          frame.print();
        }, 100);

      } catch (e) { console.log(e); }

      
    },
  },
  async mounted() {
    this.userID = this.$route.params.userID;
    this.config = this.$route.params.config;
    this.jobNo = this.$route.params.jobNo;

    if (this.userID && this.config && this.jobNo) { this.pdfClicked(); }
  }
}

</script>

<style lang="scss">
@import '@/css/all.scss';

.js-report-main {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  > iframe {
    width: 100%;
    height: 100%;
  }

  > .error-message {
    color: red;
    width: 100%;
    text-align: center;
    margin-top: 5px;
    white-space: pre-wrap;
  }
}
</style>
